import { render, staticRenderFns } from "./EvidenceModal.vue?vue&type=template&id=df3806b6&scoped=true"
import script from "./EvidenceModal.vue?vue&type=script&lang=js"
export * from "./EvidenceModal.vue?vue&type=script&lang=js"
import style0 from "./EvidenceModal.vue?vue&type=style&index=0&id=df3806b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3806b6",
  null
  
)

export default component.exports